/* Infinite scroll for the collection product grid, with eager
   prefetching: the next page is fetched and parsed ahead of time, so
   when the sentinel nears the viewport the cards append instantly from
   the buffer (and the following page starts prefetching right away).
   Rebinds after facet/filter re-renders and repaints tier pricing on
   appended cards.

   This Dawn's pagination arrows carry scrambled classes/labels (the
   "Next page" arrow on the last page points backwards), so the next
   page number is tracked here rather than read from pagination links,
   and appends are deduped by product URL. */
(function () {
  if (window.__millianInfinite) return;
  window.__millianInfinite = true;

  function hasMorePages(root) {
    return Boolean(
      (root || document).querySelector('.pagination__list a[href*="page="]')
    );
  }

  function pageUrl(n) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', n);
    return u.toString();
  }

  function hidePagination(scope) {
    (scope || document).querySelectorAll('.pagination-wrapper, .pagination').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function itemKey(item) {
    var a = item.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  function setup() {
    var grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.millianInfinite) return;
    if (!hasMorePages(document)) return;
    grid.dataset.millianInfinite = '1';
    hidePagination();

    // Drop any sentinel left from a replaced grid (facet re-render) so
    // its orphaned observer can never fire again.
    document.querySelectorAll('[data-millian-infinite-sentinel]').forEach(function (el) { el.remove(); });

    var page = 2;
    var done = false;
    var fetching = false;
    var buffer = null; // parsed product nodes of the NEXT page, ready to append
    var wantAppend = false; // sentinel reached before the buffer was ready

    var sentinel = document.createElement('div');
    sentinel.setAttribute('data-millian-infinite-sentinel', '');
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';
    // Dawn's div:empty{display:none} hides an empty div, and a hidden
    // element never intersects - inline display beats that rule.
    sentinel.style.display = 'block';
    grid.parentElement.appendChild(sentinel);

    function appendBuffer() {
      if (!buffer) return;
      var nodes = buffer;
      buffer = null;
      var seen = {};
      grid.querySelectorAll('.grid__item').forEach(function (it) {
        var k = itemKey(it);
        if (k) seen[k] = true;
      });
      var appended = 0;
      nodes.forEach(function (child) {
        var k = itemKey(child);
        // No product link = not a product card (e.g. the empty-page
        // "No products found" markup) - never append those.
        if (!k || seen[k]) return;
        grid.appendChild(child);
        appended++;
      });
      if (appended > 0) {
        page++;
        if (window.millianPaintCardPrices) window.millianPaintCardPrices();
        prefetch(); // start pulling the page after this one immediately
      } else {
        done = true;
        io.disconnect();
      }
    }

    function prefetch() {
      if (fetching || done || buffer) return;
      fetching = true;
      fetch(pageUrl(page), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          fetching = false;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var nodes = newGrid ? Array.prototype.slice.call(newGrid.children) : [];
          var hasProducts = nodes.some(function (n) { return itemKey(n); });
          if (!hasProducts) {
            done = true;
            io.disconnect();
            return;
          }
          buffer = nodes;
          if (wantAppend) {
            wantAppend = false;
            appendBuffer();
          }
        })
        .catch(function () { fetching = false; });
    }

    var io = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        if (done) return;
        if (buffer) {
          appendBuffer();
        } else {
          wantAppend = true;
          prefetch();
        }
      },
      // Tall top margin so a fast jump to the page bottom (sentinel
      // already scrolled past, footer below it) still counts as visible.
      { rootMargin: '2000px 0px' }
    );
    io.observe(sentinel);

    // Warm the buffer right away so the first append is instant.
    prefetch();
  }

  function init() {
    setup();
    // Facet/filter updates replace the grid container's contents.
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(function () { setTimeout(setup, 100); }).observe(container, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
